import { render, staticRenderFns } from "./IssueCreateForm.vue?vue&type=template&id=2d9b871c&scoped=true&lang=pug&"
import script from "./IssueCreateForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./IssueCreateForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./IssueCreateForm.vue?vue&type=style&index=0&id=2d9b871c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b871c",
  null
  
)

export default component.exports